import axios from "axios";

export default {
  namespaced: true,
  state: {
    details: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    detailsMessage: ''
  },
  mutations: {
    CLEAR_MARKETDETAILS(state) {
      state.details = [];
    },
    RECEIVED_MARKETDETAILS(state, payload) {
      state.details = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETDETAILS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETDETAIL(state, payload) {
      state = Object.assign(state, {
        details: [...state.details, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETDETAIL(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETDETAIL(state, payload) {
      let index = state.details.findIndex(content => content._id === payload._id);
      state = Object.assign(state, {
        details: state.details.map((content, i) => {
          if (i === index) {
            return Object.assign({}, content, payload);
          }
          return content;
        }),
        isUpdating: false,
        detailsMessage: 'MarketDetails has been updating!',
      })
    },
    UPDATING_MARKETDETAIL(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETDETAIL(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.details.findIndex(content => content._id === payload._id);
      console.log(indexToDelete);
      let details = [...state.details];
      details.splice(indexToDelete, 1);
      state = Object.assign(state, {
        details: [...details],
        isDeleting: false,
        idToDelete: null,
        detailsMessage: 'MarketDetail has been Deleted!',
      });
    },
    DELETING_MARKETDETAIL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketDetailRequest({dispatch}, payload) {
      dispatch("deletingMarketDetail", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/marketdetail/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        console.log(response.data);
        dispatch("deleteMarketDetail", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectDetailRequest({dispatch}, payload) {
      try{
        dispatch("deletingMarketDetail", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/marketdetail/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMarketDetail", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMarketDetailRequest({dispatch}, payload) {
      dispatch("receivingMarketDetails");
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/marketdetail';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketDetail", response.data);
      return response.data;
    },
    async insertProjectDetailRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMarketDetail");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/marketdetail/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectDetailWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketDetail");
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/marketdetail/withimage/' + payload.projectid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketDetailsRequest({dispatch}) {
      dispatch("receivingMarketDetails");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/marketdetails';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data);
        dispatch("receiveMarketDetails", response.data);
      })
    },
    async getMarketDetailQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketDetails");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/details/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveMarketDetails", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketDetailRequest({dispatch}, payload) {
      dispatch("updatingMarketDetail");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/marketdetail/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketDetail", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateProjectDetailRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketDetail");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/marketdetail/' + payload.detailid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        console.log(response.data)
        dispatch("updateMarketDetail", response.data);
        return response.data;
      }
      catch(e){
        console.log(e)
        return null;
      }
    },
    async updateMarketDetailApproveRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketDetail");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/marketdetail/approve/' + payload.contentid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketDetail", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketDetailPendingRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketDetail");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/marketdetail/pending/' + payload.contentid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketDetail", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateProjectDetailWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketDetail");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/marketdetail/withimage/' + payload.detailid;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateMarketDetail", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketDetailImageRequest({dispatch}, payload) {
      dispatch("updatingMarketDetail");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/marketdetail/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketDetail", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    clearMarketDetails({commit}) {
      commit("CLEAR_MARKETDETAILS")
    },
    receiveMarketDetails({commit}, payload) {
      commit("RECEIVED_MARKETDETAILS", payload)
    },
    receivingMarketDetails({commit}) {
      commit("RECEIVING_MARKETDETAILS")
    },
    receiveMarketDetail({commit}, payload) {
      commit("RECEIVED_MARKETDETAIL", payload)
    },
    receivingMarketDetail({commit}) {
      commit("RECEIVING_MARKETDETAIL")
    },
    updateMarketDetail({commit}, payload) {
      commit("UPDATED_MARKETDETAIL", payload)
    },
    updatingMarketDetail({commit}) {
      commit("UPDATING_MARKETDETAIL")
    },
    deleteMarketDetail({commit}, payload) {
      commit("DELETED_MARKETDETAIL", payload)
    },
    deletingMarketDetail({commit}, payload) {
      commit("DELETING_MARKETDETAIL", payload)
    }
  },
};
